import { Region } from './region';
export var Language;
(function (Language) {
    Language["en"] = "en";
    Language["id"] = "id";
    Language["ja"] = "ja";
    Language["ms"] = "ms";
    Language["th"] = "th";
    Language["vi"] = "vi";
    Language["fil"] = "fil";
    Language["fr"] = "fr";
})(Language || (Language = {}));
/**
 * language code supported by lemon8
 */
export var UILanguage;
(function (UILanguage) {
    UILanguage["en"] = "en";
    UILanguage["id"] = "id";
    UILanguage["ja"] = "ja";
    UILanguage["ms"] = "ms";
    UILanguage["th"] = "th";
    UILanguage["vi"] = "vi";
    UILanguage["fr_ca"] = "fr-CA";
})(UILanguage || (UILanguage = {}));
export const LanguageDisplayNameMap = {
    en: 'English',
    id: 'Bahasa Indonesia',
    ja: '日本語',
    ms: 'Bahasa Melayu',
    th: 'ภาษาไทย',
    vi: 'Tiếng Việt',
    fil: 'Pilipino',
    fr: 'Français',
};
export const SupportedLanguages = [
    Language.en,
    Language.id,
    Language.ja,
    Language.ms,
    Language.th,
    Language.vi,
];
export const SupportedLanguageMetas = SupportedLanguages.map((language) => ({
    language,
    displayName: LanguageDisplayNameMap[language],
})).sort((l, r) => (l.displayName > r.displayName ? 1 : -1));
export const RegionFallbackLanguageMap = {
    [Region.jp]: Language.ja,
    [Region.th]: Language.th,
    [Region.my]: Language.ms,
    [Region.id]: Language.id,
    [Region.vn]: Language.vi,
    [Region.us]: Language.en,
    [Region.gb]: Language.en,
    [Region.sg]: Language.en,
    [Region.ph]: Language.en,
    [Region.ca]: Language.en,
    [Region.au]: Language.en,
    [Region.nz]: Language.en,
};
export const RegionHrefLangMap = {
    [Region.jp]: 'ja-jp',
    [Region.th]: 'th-th',
    [Region.my]: 'ms-my',
    [Region.id]: 'id-id',
    [Region.vn]: 'vi-vn',
    [Region.us]: 'en-us',
    [Region.gb]: 'en-gb',
    [Region.sg]: 'en-sg',
    [Region.ph]: 'en-ph',
    [Region.ca]: 'en-ca',
    [Region.au]: 'en-au',
    [Region.nz]: 'en-nz',
};
